  <template>
  <b-modal style="padding:15px" size="lg" id="AddWheatIssueModal" ref="modal" title="Add Wheat Issue" ok-title="Submit" cancel-title="Close" 
      @show= "resetModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddWheatIssueForm != undefined ? !this.$refs.AddWheatIssueForm.checkValidity() : true">
        <form ref="AddWheatIssueForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
              <b-form-group  label="Date Issued" label-for="datepicker-1" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "DateIssued" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="No. Of Sacks" label-for="noOfSacks" autocomplete="off">
                <b-form-input id="noOfSacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Total Weight" label-for="Total Weight" autocomplete="off">
                <b-form-input id="TotalWeight" v-model= "TotalWeight" type = "number" required></b-form-input>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'AddCompany',
    data(){
        return{
          moduleName:'Add Wheat Issue',
          TotalWeight:0,
          NoOfSacks:0,
          DateIssued:null,     
		}
  },

methods:{

    addWheatIssue(){ 
      console.log(this.NoOfSacks)
     axios.post('/WheatIssue/Add', 
      {"IssuedDateTime":this.DateIssued,"NoOfSacks":Number(this.NoOfSacks), "IssuedWeight":Number(this.TotalWeight),
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      
      })
      .then(res=>{
        console.log(res)
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Record added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                
                 this.$bvModal.hide('AddWheatIssueModal')
                
                  this.$router.go();
                 
            }
             else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'An Error Occured!',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddWheatIssueForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.NoOfSacks = 0;
        this.TotalWeight = 0;
        this.DateIssued = null;
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addWheatIssue()
        
       
      },
 
  
  },
	

}
</script>
